<template>
  <YdDialog
    :title="title"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="60%"
    @open="openEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="100px"
    >
      <div class="title-box">活动信息</div>
      <!-- <el-form-item label="展示状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="-1">关闭</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="活动类型" prop="type">
        <el-radio-group
          v-model="form.type"
          @change="radioChange"
          :disabled="form.id && !(form.status === 0 || form.status === 1)"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="通用性活动，获取活动链接的平台用户可参与，活动页面样式通过配置实现"
            placement="top-start"
          >
            <el-radio :label="1">全体用户可参与</el-radio>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="通用性乘车活动，活动期间完成乘车订单的用户可参与，活动页面样式通过配置实现"
            placement="top-start"
          >
            <el-radio :label="2">乘车用户可参与</el-radio>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="通用性乘车活动，活动期间完成在平台内的首笔乘车订单的用户可参与，活动页面样式通过配置实现"
            placement="top-start"
          >
            <el-radio :label="3">首单乘车用户可活动</el-radio>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="特定主题活动，用户参与条件以及活动页面样式需单次设计及开发"
            placement="top-start"
          >
            <el-radio :label="4">特殊主题活动</el-radio>
          </el-tooltip>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="次数" v-show="form.type !== 4" required>
        <div class="flex flex-align-center">
          <template v-if="form.type === 1">
            <div class="margin-right-10">每人可参与: </div>
            <el-input-number
              :min="0"
              class="margin-right-10"
              v-model="form.allowedCountPerUser"
              :controls="false"
              :disabled="form.id && (form.status === 2 || form.status === -1)"
            />
            <el-select
              v-model="form.allowedPeriod"
              placeholder="默认状态：活动期间"
              :disabled="form.id && (form.status === 2 || form.status === -1)"
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="form.type === 2">
            <div class="margin-right-10">每完成</div>
            <el-input-number
              :min="0"
              class="margin-right-10"
              v-model="form.ordersPerCompleted"
              :controls="false"
              :disabled="form.id && (form.status === 2 || form.status === -1)"
            />单，
            <div class="margin-right-10">可参与</div>
            <el-input-number
              :min="0"
              class="margin-right-10"
              v-model="form.allowedCount"
              :controls="false"
              :disabled="form.id && (form.status === 2 || form.status === -1)"
            />次
          </template>
          <template v-if="form.type === 3">
            <div class="margin-right-10">完成首单乘车订单，可参与</div>
            <el-input-number
              :min="0"
              class="margin-right-10"
              v-model="form.firstOrderAllowedCount"
              :controls="false"
              :disabled="form.id && (form.status === 2 || form.status === -1)"
            />次
          </template>
        </div>
      </el-form-item>
      <el-form-item label="限制参与用户" prop="user">
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          @click="showDisabled('user')"
          v-if="restrictedPhoneList.length === 0"
          >新增用户</el-button
        >
        <div v-else class="border-line" style="width: 490px">
          <el-tag
            v-for="(tag, index) in restrictedPhoneList"
            :key="tag.phone"
            closable
            type="info"
            @close="delValue(index, 'user')"
            :disable-transitions="false"
            class="margin-right-8 margin-bottom-8"
          >
            {{ tag.phone }}
          </el-tag>
          <el-button
            type="success"
            class="margin-bottom-8"
            icon="el-icon-plus"
            plain
            @click="showDisabled('user')"
            >新增用户</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="有效线路" prop="line" v-if="form.type !== 1">
        <el-row>
          <el-col :span="3">
            <el-radio-group v-model="form.allowedLine" @change="lineChange">
              <el-radio :label="0">全部线路</el-radio>
              <el-radio class="margin-top-8" :label="1">部分线路</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="12" class="margin-top-15 margin-left-15">
            <el-button
              type="success"
              icon="el-icon-plus"
              plain
              :disabled="!form.allowedLine"
              @click="showDisabled('line')"
              v-if="allowedLineIds.length === 0"
              >新增线路</el-button
            >
            <div v-else class="border-line" style="width: 375px">
              <el-tag
                v-for="(tag, index) in allowedLineIds"
                :key="tag.lineName"
                closable
                type="info"
                @close="delValue(index, 'line')"
                :disable-transitions="false"
                class="margin-right-8 margin-bottom-8"
              >
                {{ tag.lineName }}
              </el-tag>
              <el-button
                type="success"
                icon="el-icon-plus"
                class="margin-bottom-8"
                plain
                @click="showDisabled('line')"
                :disabled="!form.allowedLine"
                >新增路线</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="活动名称" prop="name">
        <el-input
          type="text"
          placeholder="请输入活动名称"
          v-model.trim="form.name"
          maxlength="10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="活动时间" class="is-required">
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="请选择开始时间"
          :picker-options="pickerOptionStart()"
          style="width: 200px"
          :disabled="form.id && (form.status === 2 || form.status === -1)"
          @change="checkTime($event, 'start')"
        />
        <span> - </span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="请选择结束时间"
          :picker-options="pickerOptionEnd()"
          style="width: 200px"
          @change="checkTime($event, 'end')"
        />
      </el-form-item>
      <el-form-item label="活动规则" required prop="description">
        <rich-text-editor v-model="form.description" />
      </el-form-item>

      <div v-if="form.type !== 4">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div class="title-box">页面展示</div>
        </div>
        <el-row>
          <el-form-item label="页面头图" required prop="images">
            <uploadImage
              :imageList="form.images"
              :code="'activity'"
              :isShowTip="true"
              :fileType="['jpg', 'png']"
              :fileSize="1"
              :WHtip="true"
              :limit="1"
              :width="750"
              :height="588"
              :accept="'.jpg,.png'"
              @input="getHeaderImg"
              :multiple="false"
            />
          </el-form-item>
          <el-form-item label="页面背景色" required prop="backgroundColor">
            <el-color-picker v-model="form.backgroundColor" />
          </el-form-item>
          <!-- <el-form-item label="中奖名单">
            <el-radio-group v-model="form.fakeWinnerListToggle">
              <el-radio :label="1">展示</el-radio>
              <el-radio :label="2">隐藏</el-radio>
            </el-radio-group>
            <div class="flex flex-align-center margin-top-10">
              <el-button
                type="success"
                icon="el-icon-plus"
                plain
                @click="controlsPrize('add')"
                :disabled="form.fakeWinnerListToggle == 2"
                >新增虚拟中奖数据</el-button
              >
              <span class="margin-left-15 font-12">完成活动奖品配置后操作添加虚拟中奖数据</span>
            </div>
            <div>
              <div
                v-for="(item, index) in virtualList"
                :key="index"
                class="flex flex-align-center font-12 margin-top-10"
              >
                <div class="margin-right-15">记录{{ index + 1 }}：</div>
                <div>用户手机号：</div>
                <el-input
                  v-model="item.userPhone"
                  placeholder="请输入内容"
                  style="width: 200px"
                  class="margin-right-15"
                />
                <div>中奖奖品：</div>
                <el-select v-model="item.prizesId" placeholder="请选择" class="margin-right-15">
                  <el-option
                    v-for="item in prizeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-button type="danger" @click="controlsPrize('del', index)">删除</el-button>
              </div>
            </div>
          </el-form-item> -->
        </el-row>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="title-box">分享信息</div>
      </div>
      <el-form-item label="标题" prop="shareTitle" required>
        <el-input
          type="text"
          placeholder="请输入标题"
          v-model.trim="form.shareTitle"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="分享图" prop="shareImages" required>
        <uploadImage
          :imageList="form.shareImages"
          :code="'activity'"
          :isShowTip="true"
          :WHtip="true"
          :fileSize="1"
          :limit="1"
          :width="600"
          :height="480"
          :fileType="['jpg', 'png']"
          :accept="'.jpg,.png'"
          @input="getShareImg"
          :multiple="false"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <select-user :visible="userVisible" ref="selectUser" @userSubmit="selectSubmit" />
    <select-line :visible="lineVisible" ref="selectLine" @lineSubmit="selectSubmit" />
  </YdDialog>
</template>

<script>
  import RichTextEditor from '@/components/RichTextEditor/RichTextEditor'
  import selectUser from './select-user.vue'
  import selectLine from './select-line.vue'
  import { getToken } from '@/util/auth'
  import dayjs from 'dayjs'
  import { isEmpty, uniqBy } from 'lodash-es'
  import uploadImage from '@/components/ImageUpload/index'
  import { raffleCreate, raffleUpdate } from '@/api/marketing/prize-draw'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: () => {}
      }
    },
    components: {
      RichTextEditor,
      selectUser,
      selectLine,
      uploadImage
    },
    data() {
      return {
        showVisible: false,
        selectVisible: false,
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          description: [{ required: true, message: '请输入活动规则', trigger: 'blur' }],
          images: [{ required: true, message: '请上传活动头图', trigger: 'change' }],
          backgroundColor: [{ required: true, message: '请选择页面背景色', trigger: 'blur' }],
          shareTitle: [{ required: true, message: '请输入分享标题', trigger: 'blur' }],
          shareImages: [{ required: true, message: '请上传分享图', trigger: 'change' }]
        },
        form: {
          name: '',
          startTime: '',
          endTime: '',
          type: 1,
          allowedLine: 0,
          fakeWinnerListToggle: 1,
          images: [],
          allowedCountPerUser: 0, // 每人可参与次数
          allowedPeriod: 1, // 0每天 1活动期间
          allowedCount: 0, // 每完成几单可参与次数
          ordersPerCompleted: 0, // 每完成几单
          firstOrderAllowedCount: 0, // 完成首单可参与次数
          shareImages: [], // 分享图片
          shareTitle: '',
          description: ''
        },
        uploadDisabled: false,
        isEdit: false,
        title: '新增活动',
        dateOptions: [
          {
            value: 0,
            label: '每天'
          },
          {
            value: 1,
            label: '活动期间'
          }
        ],
        userVisible: false,
        lineVisible: false,
        restrictedPhoneList: [], // 限制的用户
        allowedLineIds: [], // 限制的路线
        virtualList: [] // 虚拟奖品
      }
    },
    mounted() {
      this.showVisible = this.visible
      if (!isEmpty(this.formData)) {
        this.title = '编辑'
        this.isEdit = true
        this.uploadDisabled = true
        if (this.formData.restrictedPhoneList && this.formData.restrictedPhoneList.length) {
          this.restrictedPhoneList = this.formData.restrictedPhoneList.map((phone) => ({ phone }))
        }
        if (this.formData.allowedLineList && this.formData.allowedLineList.length) {
          this.allowedLineIds = this.formData.allowedLineList.map((item) => ({
            lineName: item.name,
            id: item.id
          }))
        }
        if (this.formData.fakeList && this.formData.fakeList.length) {
          this.virtualList = this.formData.fakeList.map((item) => ({
            userPhone: item.userPhone,
            prizesId: item.prizesId
          }))
        }
        this.form = {
          ...this.form,
          ...this.formData
        }
      }
    },
    methods: {
      pickerOptionStart() {
        const startTime = dayjs(this.form.startTime)
        const s = dayjs().second()
        const m = dayjs().minute()
        const h = dayjs().hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          },
          // 时间限制
          selectableRange: startTime.isSame(dayjs(), 'day')
            ? `${h}:${m}:${s}-23:59:59`
            : '00:00:00-23:59:59'
        }
      },
      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        const startTime = dayjs(this.form.endTime)
        const s = dayjs(this.form.startTime).second()
        const m = dayjs(this.form.startTime).minute()
        const h = dayjs(this.form.startTime).hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          },
          // 时间限制
          selectableRange: startTime.isSame(dayjs(), 'day')
            ? `${h}:${m}:${s}-23:59:59`
            : '00:00:00-23:59:59' // 如果选择明天或以后，不限制时间
        }
      },
      save() {
        if (this.form.type === 1 && !this.form.allowedCountPerUser) {
          this.$message.warning('请输入可参与次数')
          return
        }
        if (this.form.type === 2 && !this.form.ordersPerCompleted) {
          this.$message.warning('请输入完成单数')
          return
        }
        if (this.form.type === 2 && !this.form.allowedCount) {
          this.$message.warning('请输入完成单数可参与次数')
          return
        }
        if (this.form.type === 3 && !this.form.firstOrderAllowedCount) {
          this.$message.warning('请输入完成首单可参与次数')
          return
        }

        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (!this.form.startTime || !this.form.endTime) {
              this.$message.info('请先选择活动时间！')
              return
            }
            const rule = this.getRule(this.form.type)
            if (this.form.type === 4) {
              this.form.images = []
              this.form.backgroundColor = ''
            }
            const params = {
              ...this.form,
              fakeList: this.virtualList || [],
              images: this.form.images.length ? this.form.images[0].url : '',
              shareImages: this.form.shareImages.length ? this.form.shareImages[0].url : '',
              rule: JSON.stringify(rule)
            }
            this.$confirm(`是否${this.isEdit ? '修改' : '新增'}活动?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(async () => {
                this.$loading()
                let result
                if (this.isEdit) {
                  result = await raffleUpdate(params)
                } else {
                  result = await raffleCreate(params)
                }
                this.$loading().close()
                if (result.code === 0) {
                  this.$message.success(`${this.isEdit ? '修改成功' : '新增成功！'}`)
                  this.$emit('saveEdit')
                }
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          } else {
            console.log('校验失败', this.form)
          }
        })
      },
      closeEdit() {
        this.uploadDisabled = false
        this.form = {
          name: '',
          startTime: '',
          endTime: '',
          type: 1,
          allowedLine: 0,
          fakeWinnerListToggle: 1,
          images: [],
          allowedCountPerUser: 0, // 每人可参与次数
          allowedPeriod: 1, // 0每天 1活动期间
          allowedCount: 0, // 每完成几单可参与次数
          ordersPerCompleted: 0, // 每完成几单
          firstOrderAllowedCount: 0, // 完成首单可参与次数
          shareImages: [],
          shareTitle: '',
          description: '',
          backgroundColor: ''
        }
        this.showVisible = false
        this.isEdit = false
        this.virtualList = []
        this.allowedLineIds = []
        this.restrictedPhoneList = []
        this.$refs.ruleForm.clearValidate()
        this.$emit('closeEdit')
      },
      showDisabled(type) {
        // 打开限制参数用户弹框
        if (type === 'user') {
          this.$refs.selectUser.open(true)
        } else {
          this.$refs.selectLine.open(true)
        }
      },
      selectSubmit(arr, type) {
        // 选择限制参与用户
        if (type === 'user') {
          this.restrictedPhoneList = uniqBy(this.restrictedPhoneList.concat(arr), 'phone')
        } else {
          this.allowedLineIds = uniqBy(this.allowedLineIds.concat(arr), 'id')
        }
      },
      delValue(index, type) {
        // 删掉限制用户/线路
        if (type === 'user') {
          this.restrictedPhoneList.splice(index, 1)
        } else {
          this.allowedLineIds.splice(index, 1)
        }
      },
      getHeaderImg(url) {
        // 设置活动头图
        this.form.images = [{ url }]
      },
      getShareImg(url) {
        // 设置分享图
        this.form.shareImages = [{ url }]
      },
      controlsPrize(type, index) {
        // 添加/删除虚拟奖品
        if (type === 'add') {
          this.virtualList.push({
            userPhone: '',
            prizesId: ''
          })
        } else {
          this.$confirm('是否删除该数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.virtualList.splice(index, 1)
          })
        }
      },
      radioChange(index) {
        // 活动类型切换
        // this.form.allowedCountPerUser = 0
        this.form.allowedPeriod = 1
        // this.form.ordersPerCompleted = 0
        // this.form.allowedCount = 0
        // this.form.firstOrderAllowedCount = 0
        // if(index === 1){
        //   this.allowedLineIds = []
        // }
      },
      getRule(type) {
        // 根据类型获取参数
        let rule = {}
        const {
          allowedCountPerUser,
          allowedPeriod,
          ordersPerCompleted,
          allowedCount,
          allowedLine,
          firstOrderAllowedCount
        } = this.form
        const restrictedPhoneList = this.restrictedPhoneList.length
          ? this.restrictedPhoneList.map((item) => item.phone)
          : []
        const allowedLineList = this.allowedLineIds.length
          ? this.allowedLineIds.map((item) => ({ id: item.id, name: item.lineName }))
          : []
        if (type === 1) {
          rule = {
            allowedCountPerUser,
            allowedPeriod,
            restrictedPhoneList
          }
        } else if (type === 2) {
          rule = {
            ordersPerCompleted,
            allowedCount,
            allowedLine,
            allowedLineList,
            restrictedPhoneList
          }
        } else if (type === 3) {
          rule = {
            firstOrderAllowedCount,
            allowedLine,
            allowedLineList,
            restrictedPhoneList
          }
        } else if (type === 4) {
          rule = {
            allowedLine,
            allowedLineList,
            restrictedPhoneList
          }
        }
        return rule
      },
      lineChange(e) {
        if (e === 0) {
          this.allowedLineIds = []
        }
      },
      checkTime(e, type) {
        const isReset = this.isTimeBeforeNow(e)
        if (isReset) {
          this.$message.warning('时间不能小于当前时间')
          const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
          type === 'start' ? (this.form.startTime = time) : (this.form.endTime = time)
        }
      },
      isTimeBeforeNow(selectedTime) {
        // 获取当前时间
        const now = dayjs()

        // 将选择的时间转换为 dayjs 对象
        const selected = dayjs(selectedTime, 'YYYY-MM-DD HH:mm:ss') // 时间格式 '2025-01-24 12:30:00'

        // 判断选择的时间是否小于当前时间
        return selected.isBefore(now) // 如果选择的时间小于当前时间，返回 true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
  .border-line {
    border: 1px solid #ddd;
    padding: 10px 10px 2px 10px;
  }
  ::v-deep {
    .el-form-item--mini .el-color-picker--mini .el-color-picker__trigger {
      width: 50px !important;
      height: 30px !important;
    }
  }
</style>
<style>
  .el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
    display: none;
  }
</style>
